import { Tag, type TagProps } from 'primereact/tag';
import { classNames } from 'primereact/utils';
import '../views/people.styles.css';

const StatusTag = (tagProps: TagProps) => {
	return (
		<Tag
			{...tagProps}
			pt={{
				value: () => ({
					className: 'font-semibold md:text-sm font-poppins',
				}),
				root: (e) => ({
					className: classNames('people-tag', {
						'people-tag-color-approval ':
							e?.props.severity === 'secondary',
						'people-tag-color-active':
							e?.props.severity === 'success',
						'bg-blue-500 ': e?.props.severity === 'info',
						'people-tag-color-pending ':
							e?.props.severity === 'warning',
						'bg-red-500 ': e?.props.severity === 'danger',
					}),
				}),
			}}
		/>
	);
};

export default StatusTag;
